export const categoryLandingContent = {
  'genre:lofi': {
    title: 'Free Lofi Music for Videos, Podcasts & Streams',
    body: [
      'Lofi music works well when your project needs a calm background that supports narration, study sessions, livestreams, vlogs, or social edits without stealing attention.',
      'Use these chill tracks for YouTube videos, podcast beds, stream intros, study playlists, and commercial creator projects under Viberary license terms.'
    ],
    links: [
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' },
      { label: 'Livestream music guide', to: '/free-music-for-livestreams' }
    ]
  },
  'genre:livestream': {
    title: 'Free Livestream Music for Creators',
    body: [
      'Livestream music should sit comfortably behind speaking, gameplay, chat, or live demonstrations. This collection focuses on background-friendly tracks for real-time content.',
      'Preview tracks before going live, keep the license page handy, and use music that fits the pace of your stream.'
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Livestream music guide', to: '/free-music-for-livestreams' }
    ]
  },
  'genre:cinematic-epic': {
    title: 'Free Cinematic Epic Music for Videos',
    body: [
      'Cinematic and epic tracks help trailers, sports edits, film scenes, game content, documentaries, and adventure videos feel larger and more dramatic.',
      'Choose a track that supports the emotional arc of your scene, then review the download page and license terms before publishing.'
    ],
    links: [
      { label: 'Adventure music', to: '/mood/adventure' },
      { label: 'Action / Sports music', to: '/mood/action-sports' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:k-drama-ost': {
    title: 'Free K-Drama OST Music for Videos',
    body: [
      'K-Drama OST style music is useful for romantic edits, emotional storytelling, short films, drama recaps, character moments, and sentimental creator projects.',
      'Use these tracks when your video needs a softer story-driven mood, then follow the visible license terms on the download page.'
    ],
    links: [
      { label: 'Romantic music', to: '/mood/romantic' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:holiday-christmas': {
    title: 'Free Holiday Christmas Music for Videos',
    body: [
      'Holiday and Christmas music supports seasonal videos, festive ads, family vlogs, product promos, shorts, and social content during the busiest creator season.',
      'Preview cheerful, cozy, and magical tracks for seasonal creator projects.'
    ],
    links: [
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Magical music', to: '/genre/magical' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:ambient-atmospheric': {
    title: 'Free Ambient Atmospheric Music for Videos',
    body: [
      'Ambient atmospheric music is best when you need space, calm, and texture: meditation videos, sleep content, nature footage, documentaries, podcasts, and quiet scenes.',
      'Pick tracks that support the pace of your visuals or narration without crowding the message.'
    ],
    links: [
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Free background music', to: '/free-background-music-for-videos' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' }
    ]
  },
  'genre:jazz-bossa': {
    title: 'Free Jazz and Bossa Nova Music for Videos',
    body: [
      'Jazz and bossa nova tracks add warmth, lounge energy, and stylish background texture to cafe videos, restaurant promos, travel vlogs, podcasts, and lifestyle content.',
      'Use this collection when your project needs a relaxed but polished sound.'
    ],
    links: [
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Vlog / Travel music', to: '/mood/vlog-travel' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' }
    ]
  },
  'mood:chillout': {
    title: 'Free Chillout Music for Background Videos',
    body: [
      'Chillout music is one of the safest starting points for background use because it can support videos, podcasts, streams, study sessions, and product content without feeling too intense.',
      'Preview relaxing tracks and choose one that leaves room for voice, dialogue, or visual pacing.'
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Ambient music', to: '/genre/ambient-atmospheric' },
      { label: 'Free background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'mood:happy': {
    title: 'Free Happy Music for YouTube & Social Videos',
    body: [
      'Happy music is a strong fit for positive YouTube videos, family-friendly edits, brand moments, product demos, social posts, and optimistic commercial projects.',
      'Use these upbeat tracks when your content needs energy, warmth, or a clear feel-good tone.'
    ],
    links: [
      { label: 'Pop music', to: '/genre/pop' },
      { label: 'Cute music', to: '/mood/cute' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:corporate': {
    title: 'Free Corporate Music for Business Videos',
    body: [
      'Corporate music works best for business videos, product demos, explainer videos, pitch decks, training content, presentations, and brand campaigns.',
      'Choose a track that feels confident and clean, then review the license terms before adding it to your commercial project.'
    ],
    links: [
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' },
      { label: 'Optimistic music', to: '/mood/optimistic' },
      { label: 'Inspirational music', to: '/mood/inspirational' }
    ]
  },
  'mood:vlog-travel': {
    title: 'Free Vlog and Travel Music for Creators',
    body: [
      'Vlog and travel music helps creator content feel personal, moving, and easy to watch across YouTube, reels, lifestyle edits, podcasts, and commercial social posts.',
      'Preview tracks that match your pacing, destination, or story, then download from the track page.'
    ],
    links: [
      { label: 'Road Trip music', to: '/mood/road-trip' },
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:anime': {
    title: 'Free Anime Music for Videos and AMV Edits',
    body: [
      'Anime style music suits AMV edits, gaming montages, cosplay videos, storytelling channels, intros, and energetic or emotional creator projects.',
      'Preview each track, match it to the mood of your scene, and review the visible license terms before you download and publish.'
    ],
    links: [
      { label: 'Magical music', to: '/genre/magical' },
      { label: 'Cinematic Epic music', to: '/genre/cinematic-epic' },
      { label: 'Anime music guide', to: '/free-anime-music' }
    ]
  },
  'genre:bubblegum': {
    title: 'Free Bubblegum Pop Music for Videos',
    body: [
      'Bubblegum pop music brings bright, playful, feel good energy to hauls, beauty content, product promos, kids content, vlogs, and upbeat social videos.',
      'Use these cheerful tracks when your video needs a fun and catchy tone, then follow the license terms shown on the download page.'
    ],
    links: [
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Cute music', to: '/mood/cute' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:magical': {
    title: 'Free Magical and Fantasy Music for Videos',
    body: [
      'Magical and fantasy music adds wonder to storytelling videos, game content, kids projects, whimsical animations, and dreamy or enchanted scenes.',
      'Pick a track that matches the sense of wonder in your visuals, then review the license terms before publishing.'
    ],
    links: [
      { label: 'Anime music', to: '/genre/anime' },
      { label: 'Cinematic music', to: '/mood/cinematic' },
      { label: 'Anime music guide', to: '/free-anime-music' }
    ]
  },
  'mood:magical': {
    title: 'Free Magical Mood Music for Whimsical Videos',
    body: [
      'A magical mood can make fairytale scenes, fantasy stories, game videos, kids projects, and whimsical animations feel more curious, dreamy, or enchanted.',
      'Compare the pacing and atmosphere of each track, then review the visible license terms on its download page before publishing.'
    ],
    links: [
      { label: 'Magical and Fantasy music', to: '/genre/magical' },
      { label: 'Anime music', to: '/genre/anime' },
      { label: 'Cinematic music', to: '/mood/cinematic' },
      { label: 'Anime music guide', to: '/free-anime-music' }
    ]
  },
  'genre:pop': {
    title: 'Free Pop Music for Videos and Social Content',
    body: [
      'Pop music is a flexible choice for vlogs, brand videos, product promos, social edits, and upbeat commercial content that needs a modern, familiar feel.',
      'Preview tracks that fit your pacing and energy, then check the visible license terms before you download.'
    ],
    links: [
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Bubblegum music', to: '/genre/bubblegum' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:classical': {
    title: 'Free Classical Music for Videos and Films',
    body: [
      'Classical style music suits films, documentaries, wedding videos, study and focus content, luxury brand promos, and elegant storytelling.',
      'Choose a piece that supports the tone of your scene, then review the license terms on the download page.'
    ],
    links: [
      { label: 'Wedding music', to: '/mood/wedding' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'Background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'genre:dance-electronic': {
    title: 'Free Dance and Electronic Music for Videos',
    body: [
      'Dance and electronic music drives energy in gaming videos, sports edits, tech reviews, product launches, workout content, and high tempo promos.',
      'Preview tracks that match the pace of your edit, then follow the visible license terms before publishing.'
    ],
    links: [
      { label: 'Action and Sports music', to: '/mood/action-sports' },
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:funk': {
    title: 'Free Funk Music for Videos and Ads',
    body: [
      'Funk music brings groove and confidence to ads, fashion content, product promos, retro edits, and upbeat lifestyle videos.',
      'Use these rhythmic tracks when your project needs a stylish, energetic feel, then check the license terms before you download.'
    ],
    links: [
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Pop music', to: '/genre/pop' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:reggae': {
    title: 'Free Reggae Music for Videos and Vlogs',
    body: [
      'Reggae style music sets a warm, laid back mood for summer vlogs, travel videos, beach content, food videos, and relaxed brand promos.',
      'Preview tracks that fit your relaxed pacing, then review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Vlog and Travel music', to: '/mood/vlog-travel' },
      { label: 'Road Trip music', to: '/mood/road-trip' },
      { label: 'Vlog music guide', to: '/free-music-for-vlogs' }
    ]
  },
  'genre:rnb-soul': {
    title: 'Free R&B and Soul Music for Videos',
    body: [
      'R&B and soul style music adds warmth and smoothness to lifestyle videos, fashion content, beauty edits, mood pieces, and modern brand promos.',
      'Choose a track that supports the emotion of your edit, then follow the license terms shown on the download page.'
    ],
    links: [
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Romantic music', to: '/mood/romantic' },
      { label: 'Background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'genre:rock': {
    title: 'Free Rock Music for Videos and Sports Edits',
    body: [
      'Rock music powers sports edits, gaming montages, action videos, product launches, and any project that needs drive and intensity.',
      'Preview tracks that match your energy, then review the visible license terms before you publish.'
    ],
    links: [
      { label: 'Action and Sports music', to: '/mood/action-sports' },
      { label: 'Anthemic music', to: '/genre/anthemic' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'genre:anthemic': {
    title: 'Free Anthemic Music for Videos and Trailers',
    body: [
      'Anthemic music delivers a big, uplifting, crowd ready feel for trailers, sports moments, inspirational ads, brand films, and highlight reels.',
      'Use these uplifting tracks to build momentum in your project, then check the license terms before publishing.'
    ],
    links: [
      { label: 'Inspirational music', to: '/mood/inspirational' },
      { label: 'Cinematic Epic music', to: '/genre/cinematic-epic' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'genre:spoken-word': {
    title: 'Free Spoken Word Backing Music for Creators',
    body: [
      'Spoken word projects need gentle backing music that supports the voice without competing with it, which also works for narration and reflective videos.',
      'Preview soft instrumental beds, keep the voice in front, and review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Spoken Poetry music', to: '/mood/spoken-poetry' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' },
      { label: 'Background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'mood:wedding': {
    title: 'Free Wedding Music for Videos and Films',
    body: [
      'Wedding music supports ceremony videos, highlight films, save the date clips, slideshows, and heartfelt anniversary content.',
      'Choose romantic and emotional tracks that fit the moment, then review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Romantic music', to: '/mood/romantic' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'Classical music', to: '/genre/classical' }
    ]
  },
  'mood:romantic': {
    title: 'Free Romantic Music for Videos and Edits',
    body: [
      'Romantic music brings tenderness to love stories, couple edits, wedding videos, proposal clips, and emotional storytelling.',
      'Preview tracks that match the warmth of your scene, then follow the license terms on the download page.'
    ],
    links: [
      { label: 'Wedding music', to: '/mood/wedding' },
      { label: 'K-Drama OST music', to: '/genre/k-drama-ost' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:cinematic': {
    title: 'Free Cinematic Music for Videos and Films',
    body: [
      'Cinematic music adds scale and emotion to films, trailers, documentaries, brand stories, and dramatic scenes.',
      'Choose a track that follows the arc of your scene, then review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Cinematic Epic music', to: '/genre/cinematic-epic' },
      { label: 'Adventure music', to: '/mood/adventure' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'mood:acoustic': {
    title: 'Free Acoustic Music for Videos and Vlogs',
    body: [
      'Acoustic music gives vlogs, lifestyle videos, ads, and heartfelt content a warm, honest, and personal feel.',
      'Preview organic, guitar led tracks that leave room for narration, then check the license terms before you download.'
    ],
    links: [
      { label: 'Vlog and Travel music', to: '/mood/vlog-travel' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'Vlog music guide', to: '/free-music-for-vlogs' }
    ]
  },
  'mood:adventure': {
    title: 'Free Adventure Music for Travel and Action Videos',
    body: [
      'Adventure music energizes travel videos, outdoor and hiking content, action edits, and inspiring journey stories.',
      'Preview uplifting tracks that match your movement and pacing, then review the visible license terms.'
    ],
    links: [
      { label: 'Cinematic Epic music', to: '/genre/cinematic-epic' },
      { label: 'Road Trip music', to: '/mood/road-trip' },
      { label: 'Vlog music guide', to: '/free-music-for-vlogs' }
    ]
  },
  'mood:cute': {
    title: 'Free Cute Music for Videos and Kids Content',
    body: [
      'Cute music suits kids videos, pet content, craft tutorials, unboxings, and light hearted social posts.',
      'Use playful, sweet tracks to keep a friendly tone, then follow the license terms before publishing.'
    ],
    links: [
      { label: 'Bubblegum music', to: '/genre/bubblegum' },
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:action-sports': {
    title: 'Free Action and Sports Music for Edits',
    body: [
      'Action and sports music drives highlight reels, workout videos, gaming montages, and fast paced promos.',
      'Preview intense tracks that match your cuts, then check the visible license terms before publishing.'
    ],
    links: [
      { label: 'Rock music', to: '/genre/rock' },
      { label: 'Dance and Electronic music', to: '/genre/dance-electronic' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'mood:comedy': {
    title: 'Free Comedy Music for Funny Videos',
    body: [
      'Comedy music adds timing and fun to skits, meme videos, bloopers, and light hearted brand content.',
      'Preview quirky tracks that support the joke, then review the license terms before you download.'
    ],
    links: [
      { label: 'Cute music', to: '/mood/cute' },
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:cool': {
    title: 'Free Cool Music for Videos and Fashion Edits',
    body: [
      'Cool music brings a confident, modern edge to fashion edits, tech reviews, product reveals, and stylish brand content.',
      'Preview tracks that match your look and pacing, then follow the visible license terms.'
    ],
    links: [
      { label: 'Funk music', to: '/genre/funk' },
      { label: 'R&B and Soul music', to: '/genre/rnb-soul' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'mood:inspirational': {
    title: 'Free Inspirational Music for Videos and Ads',
    body: [
      'Inspirational music lifts motivational videos, brand stories, nonprofit campaigns, and hopeful, forward looking content.',
      'Choose an uplifting track that builds toward your message, then review the license terms before publishing.'
    ],
    links: [
      { label: 'Anthemic music', to: '/genre/anthemic' },
      { label: 'Optimistic music', to: '/mood/optimistic' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'mood:optimistic': {
    title: 'Free Optimistic Music for Upbeat Videos',
    body: [
      'Optimistic music keeps vlogs, explainers, product demos, and social videos feeling bright, positive, and easy to watch.',
      'Preview upbeat tracks that support your narration, then check the visible license terms.'
    ],
    links: [
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Inspirational music', to: '/mood/inspirational' },
      { label: 'YouTube creator guide', to: '/free-music-for-youtube-creators' }
    ]
  },
  'mood:road-trip': {
    title: 'Free Road Trip Music for Travel Videos',
    body: [
      'Road trip music fits travel vlogs, driving footage, summer edits, and easygoing adventure content.',
      'Preview relaxed, rolling tracks that match your journey, then follow the license terms before publishing.'
    ],
    links: [
      { label: 'Vlog and Travel music', to: '/mood/vlog-travel' },
      { label: 'Adventure music', to: '/mood/adventure' },
      { label: 'Vlog music guide', to: '/free-music-for-vlogs' }
    ]
  },
  'mood:sentimental': {
    title: 'Free Sentimental Music for Emotional Videos',
    body: [
      'Sentimental music supports tributes, memory montages, wedding videos, and heartfelt storytelling.',
      'Choose tender tracks that leave space for the moment, then review the visible license terms.'
    ],
    links: [
      { label: 'Romantic music', to: '/mood/romantic' },
      { label: 'Wedding music', to: '/mood/wedding' },
      { label: 'K-Drama OST music', to: '/genre/k-drama-ost' }
    ]
  },
  'mood:spy-suave': {
    title: 'Free Spy and Suave Music for Videos',
    body: [
      'Spy and suave music adds a sleek, mysterious, confident mood to stylish edits, product reveals, and dramatic promos.',
      'Preview cool, cinematic tracks that fit your reveal, then check the license terms before you download.'
    ],
    links: [
      { label: 'Cool music', to: '/mood/cool' },
      { label: 'Cinematic music', to: '/mood/cinematic' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  },
  'mood:spoken-poetry': {
    title: 'Free Music for Spoken Poetry and Narration',
    body: [
      'Spoken poetry and narration need soft background music that supports the voice, which also fits reflective and storytelling videos.',
      'Preview gentle instrumental beds, keep the voice clear, and review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Spoken Word music', to: '/genre/spoken-word' },
      { label: 'Podcast music guide', to: '/free-music-for-podcasts' },
      { label: 'Background music guide', to: '/free-background-music-for-videos' }
    ]
  },
  'mood:anthemic': {
    title: 'Free Anthemic and Uplifting Music for Videos',
    body: [
      'An anthemic mood gives inspiring videos, sports moments, brand films, and highlight reels a big, motivating, crowd ready lift.',
      'Preview motivating tracks that build toward your key moment, then review the visible license terms before publishing.'
    ],
    links: [
      { label: 'Anthemic music', to: '/genre/anthemic' },
      { label: 'Inspirational music', to: '/mood/inspirational' },
      { label: 'Commercial use guide', to: '/free-music-for-commercial-use' }
    ]
  }
};

export const defaultLibraryIntro = {
  title: 'Free Music for Commercial Use',
  body: [
    'Browse royalty-free music for YouTube videos, podcasts, livestreams, ads, games, presentations, vlogs, and social content.',
    'Preview tracks, review the visible license terms, and download the version that fits your creator project.'
  ],
  links: [
    { label: 'YouTube music guide', to: '/free-music-for-youtube-creators' },
    { label: 'Commercial use guide', to: '/free-music-for-commercial-use' },
    { label: 'License Terms', to: '/license-terms' }
  ]
};

export const soundEffectsIntro = {
  title: 'Free Sound Effects for Videos and Games',
  body: [
    'Use Viberary sound effects to add notifications, transitions, reactions, and atmosphere to videos, games, podcasts, apps, and social content.',
    'Preview each sound, review the license terms, and download from the dedicated sound effect page.'
  ],
  links: [
    { label: 'Sound effects guide', to: '/sound-effects-for-videos' },
    { label: 'License Terms', to: '/license-terms' },
    { label: 'Contact', to: '/contact-us' }
  ]
};

export const creatorGuides = {
  '/free-music-for-youtube-creators': {
    title: 'Free Music for YouTube Creators',
    description: 'Find free royalty-free music for YouTube videos, Shorts, intros, vlogs, tutorials, and monetized creator projects.',
    sections: [
      {
        heading: 'Music for monetized YouTube videos',
        body: 'Viberary helps creators find music for YouTube videos, Shorts, vlogs, tutorials, explainers, product videos, and social edits. Choose a track, review the visible license terms, and keep the download page URL with your project notes.'
      },
      {
        heading: 'Best starting categories',
        body: 'Start with Lofi, Chillout, Happy, Corporate, Cinematic / Epic, Vlog / Travel, Jazz / Bossa Nova, and Ambient / Atmospheric depending on the tone of your video.'
      },
      {
        heading: 'Creator checklist',
        body: 'Preview the track, confirm it fits your narration or edit, read the license terms, copy any attribution text shown on the download page, and avoid claiming the music as your own original composition.'
      }
    ],
    links: [
      { label: 'Browse music', to: '/music' },
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'License Terms', to: '/license-terms' }
    ]
  },
  '/free-music-for-commercial-use': {
    title: 'Free Music for Commercial Use',
    description: 'Browse free music for ads, business videos, product demos, podcasts, livestreams, games, and other commercial creator projects.',
    sections: [
      {
        heading: 'Commercial project music',
        body: 'Viberary tracks can support commercial projects such as ads, product demos, presentations, training videos, livestreams, podcasts, games, client work, and social campaigns when the use follows the posted license terms.'
      },
      {
        heading: 'What to check before publishing',
        body: 'Review the download page and license terms, keep the track page URL, follow attribution instructions where required, and make sure the selected track fits the actual project usage.'
      }
    ],
    links: [
      { label: 'Corporate music', to: '/mood/corporate' },
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Contact Viberary', to: '/contact-us' }
    ]
  },
  '/royalty-free-music-vs-copyright-free-music': {
    title: 'Royalty-Free Music vs Copyright-Free Music',
    description: 'Understand the difference between royalty-free, copyright-free, and copyright-safe music before choosing tracks for creator projects.',
    sections: [
      {
        heading: 'Royalty-free does not mean owner-free',
        body: 'Royalty-free usually means you can use a track under license without paying per-use royalties. It does not automatically mean the music has no copyright owner.'
      },
      {
        heading: 'Copyright-safe means follow the license',
        body: 'Viberary uses copyright-safe language to point creators toward tracks with visible usage terms. Always read the license terms and attribution instructions before using a track in a public project.'
      }
    ],
    links: [
      { label: 'License Terms', to: '/license-terms' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Browse music', to: '/music' }
    ]
  },
  '/free-music-for-podcasts': {
    title: 'Free Music for Podcasts',
    description: 'Find free music for podcast intros, outros, transitions, narration beds, trailers, and commercial podcast projects.',
    sections: [
      {
        heading: 'Podcast-friendly music',
        body: 'Podcast music should support speech without competing with it. Lofi, Chillout, Jazz / Bossa Nova, Corporate, Ambient / Atmospheric, Spoken Word, and Cool tracks are good starting points.'
      },
      {
        heading: 'How to use it',
        body: 'Use Viberary tracks for intros, outros, short transitions, trailers, or soft background beds. Review the license terms and save the track page URL with your episode production notes.'
      }
    ],
    links: [
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Jazz / Bossa Nova music', to: '/genre/jazz-bossa' },
      { label: 'Spoken Word music', to: '/genre/spoken-word' }
    ]
  },
  '/free-music-for-livestreams': {
    title: 'Free Music for Livestreams',
    description: 'Browse free background music for livestreams, stream intros, waiting screens, podcasts, and live creator content.',
    sections: [
      {
        heading: 'Background music for live content',
        body: 'Livestream music should sit behind speaking, chat, gameplay, demos, or waiting screens. Look for tracks that are steady, background-friendly, and not too distracting.'
      },
      {
        heading: 'Recommended categories',
        body: 'Start with Livestream, Lofi, Chillout, Cool, Corporate, Ambient / Atmospheric, and Happy depending on the energy of your stream.'
      }
    ],
    links: [
      { label: 'Livestream music', to: '/genre/livestream' },
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'License Terms', to: '/license-terms' }
    ]
  },
  '/free-background-music-for-videos': {
    title: 'Free Background Music for Videos',
    description: 'Find free background music for videos, narration, tutorials, reels, ads, games, and social content.',
    sections: [
      {
        heading: 'Choose music that supports the story',
        body: 'Background music should match the pace and emotion of the video while leaving space for dialogue, voiceover, or on-screen action.'
      },
      {
        heading: 'Useful starting points',
        body: 'Try Chillout, Lofi, Ambient / Atmospheric, Corporate, Jazz / Bossa Nova, Happy, Sentimental, and Cinematic / Epic for different video styles.'
      }
    ],
    links: [
      { label: 'Browse music', to: '/music' },
      { label: 'Chillout music', to: '/mood/chillout' },
      { label: 'Corporate music', to: '/mood/corporate' }
    ]
  },
  '/sound-effects-for-videos': {
    title: 'Sound Effects for Videos',
    description: 'Download free sound effects for videos, games, apps, podcasts, notifications, transitions, and social content.',
    sections: [
      {
        heading: 'Sound effects for creator projects',
        body: 'Sound effects can make transitions, notifications, jokes, UI moments, reactions, and games feel more polished. Viberary gives each sound effect a dedicated download page with usage context.'
      },
      {
        heading: 'Before publishing',
        body: 'Preview the effect, confirm it is not confused with a download button or ad element, review the license terms, and keep the sound effect page URL for your project notes.'
      }
    ],
    links: [
      { label: 'Browse sound effects', to: '/soundeffects' },
      { label: 'License Terms', to: '/license-terms' },
      { label: 'Contact', to: '/contact-us' }
    ]
  },
  '/free-music-for-vlogs': {
    title: 'Free Music for Vlogs and Travel Videos',
    description: 'Find free vlog and travel video music for YouTube, reels, lifestyle edits, and commercial creator projects, with license terms shown on every track.',
    sections: [
      {
        heading: 'What makes good vlog and travel music',
        body: 'Vlog and travel music should feel personal and keep momentum without covering your narration. Acoustic, lofi, jazz and bossa nova, happy, and easygoing pop tracks all work well for day in the life clips, city walks, and destination footage.'
      },
      {
        heading: 'Match the music to your footage',
        body: 'Use brighter, upbeat tracks for fast travel montages and calmer acoustic or lofi beds for reflective voiceover moments. Preview a few options against your rough cut before committing so the tempo fits your pacing.'
      },
      {
        heading: 'Edit around natural musical changes',
        body: 'Mark the intro, major beat changes, quieter passages, and ending before you finish the cut. Those points can guide scene changes, map transitions, title cards, and the move from a montage back to spoken narration.'
      },
      {
        heading: 'Keep narration easy to understand',
        body: 'Lower the music beneath speech and check the mix on headphones and a phone speaker. If a track competes with the voice, use a calmer section, shorten the music bed, or choose a less crowded arrangement.'
      },
      {
        heading: 'Free for creator and commercial vlogs',
        body: 'Viberary tracks can support monetized vlogs, sponsored travel content, and commercial creator projects when the use follows the visible license terms. Review the download page, copy any required attribution, and keep the track URL with your project notes.'
      }
    ],
    links: [
      { label: 'Vlog and Travel music', to: '/mood/vlog-travel' },
      { label: 'Acoustic music', to: '/mood/acoustic' },
      { label: 'Lofi music', to: '/genre/lofi' },
      { label: 'Jazz and Bossa Nova music', to: '/genre/jazz-bossa' },
      { label: 'Happy music', to: '/mood/happy' }
    ]
  },
  '/free-anime-music': {
    title: 'Free Anime-Style Music for Videos and Streams',
    description: 'Find free anime-style music for AMV edits, gaming videos, cosplay content, streams, and commercial creator projects, with visible license terms.',
    sections: [
      {
        heading: 'Where to find free anime-style music',
        body: 'Using music from a released anime or its official soundtrack normally requires permission from the relevant rights holders. Viberary offers an anime-style category alongside magical, cinematic, and electronic tracks for creators who need an energetic or emotional feel with visible usage terms.'
      },
      {
        heading: 'Good uses for anime-style tracks',
        body: 'Anime-style music suits AMV edits, gaming montages, cosplay videos, character intros, storytelling channels, and emotional recap videos. Pick high energy tracks for action edits and softer, dramatic tracks for emotional scenes.'
      },
      {
        heading: 'Choose a sound without copying a franchise',
        body: 'Describe the energy, instrumentation, and pacing you need instead of searching only for a specific show or character. That approach makes it easier to find music that supports the edit without suggesting that your project is officially connected to a franchise.'
      },
      {
        heading: 'Cut action and emotion differently',
        body: 'For action, line up major cuts with clear rhythmic changes and leave space for dialogue or game audio. For emotional scenes, use a gentler passage and avoid changing tracks too often so the story remains the focus.'
      },
      {
        heading: 'Use licensed music responsibly',
        body: 'Review the Viberary download page and its current license terms, follow any attribution instructions, and keep the track URL with your project notes. Music permission does not replace any permission you may need for footage, characters, artwork, or other material in the finished video.'
      }
    ],
    links: [
      { label: 'Anime music', to: '/genre/anime' },
      { label: 'Magical and Fantasy music', to: '/genre/magical' },
      { label: 'Cinematic Epic music', to: '/genre/cinematic-epic' },
      { label: 'Dance and Electronic music', to: '/genre/dance-electronic' },
      { label: 'K-Drama OST music', to: '/genre/k-drama-ost' }
    ]
  },
  '/free-christmas-music': {
    title: 'Free Christmas and Holiday Music for Videos',
    description: 'Find free Christmas and holiday music for festive videos, ads, vlogs, and commercial campaigns, with license terms shown on every track.',
    sections: [
      {
        heading: 'Music for the busiest creator season',
        body: 'The holiday season is peak time for festive videos, seasonal ads, and gift guides. Free Christmas and holiday music helps family vlogs, product promos, shorts, and social posts feel cozy, cheerful, or magical.'
      },
      {
        heading: 'Pick the right festive mood',
        body: 'Use bright, cheerful tracks for upbeat holiday hauls and gift guides, and warm, gentle tracks for sentimental family moments and year in review videos. Preview a few options to match the tone of your footage.'
      },
      {
        heading: 'Build a clean seasonal edit',
        body: 'Choose a track with enough room for product details, dialogue, or a voiceover. Natural musical changes can support gift reveals, scene transitions, price cards, and calls to action without making the video feel rushed.'
      },
      {
        heading: 'Prepare versions for each channel',
        body: 'A longer music bed can support a full video while a short section may work better for reels, ads, or end cards. Check each export on a phone-sized screen and speaker so speech, captions, and campaign details remain clear.'
      },
      {
        heading: 'Free for holiday campaigns',
        body: 'Viberary holiday tracks can support seasonal ads and commercial campaigns when the use follows the visible license terms. Review the download page, follow any required attribution, and keep the track URL with your campaign notes.'
      }
    ],
    links: [
      { label: 'Holiday Christmas music', to: '/genre/holiday-christmas' },
      { label: 'Happy music', to: '/mood/happy' },
      { label: 'Acoustic music', to: '/mood/acoustic' },
      { label: 'Sentimental music', to: '/mood/sentimental' },
      { label: 'Magical and Fantasy music', to: '/genre/magical' }
    ]
  }
};

export const faqRecommendations = [
  {
    question: 'Can I use Viberary music in monetized YouTube videos?',
    answer: 'Viberary tracks are provided for creator projects, including YouTube videos and monetized content, subject to the Viberary license terms shown on the site. Always review the license terms on the download page before publishing.'
  },
  {
    question: 'Is Viberary music free for commercial use?',
    answer: 'Viberary offers free music for personal and commercial projects under its posted license terms. Commercial uses can include videos, podcasts, ads, presentations, livestreams, and social content when they follow those terms.'
  },
  {
    question: 'Is Viberary music royalty-free?',
    answer: 'Viberary music is intended to be used without paying per-use royalties, subject to the license terms provided on Viberary. Review each download page and the license terms before using a track.'
  },
  {
    question: 'Is Viberary music copyright-free?',
    answer: 'No. Copyright-free and royalty-free are not the same thing. Viberary provides copyright-safe music for approved uses under its license terms, but the music may still be protected by copyright.'
  },
  {
    question: 'Can I use Viberary music in podcasts?',
    answer: 'Yes, Viberary music can be used in podcast projects when the use follows the posted license terms. Browse podcast-friendly categories such as Lofi, Chillout, Jazz / Bossa Nova, Spoken Word, and Corporate.'
  },
  {
    question: 'Can I use Viberary music in livestreams?',
    answer: 'Viberary includes livestream-friendly music for background use in live creator content. Review the license terms, then browse Livestream, Lofi, Chillout, Cool, and Corporate categories.'
  },
  {
    question: 'Do I need to give attribution?',
    answer: 'Follow the attribution instructions shown in Viberary license terms and on the download page for the track or sound effect you use.'
  },
  {
    question: 'Can I use Viberary sound effects in videos and games?',
    answer: 'Viberary sound effects can be used in creator projects according to the posted license terms. Check the sound effect download page for the correct attribution and usage details.'
  },
  {
    question: 'What kind of music is best for YouTube background music?',
    answer: 'For background music, start with Lofi, Chillout, Ambient / Atmospheric, Jazz / Bossa Nova, Corporate, Happy, and Vlog / Travel. Choose a track that supports the video without covering narration or dialogue.'
  },
  {
    question: 'How do I choose music that is safe for monetization?',
    answer: 'Use tracks from Viberary public library, keep a record of the download page and license terms, follow any attribution instructions, and avoid claiming the music as your own original composition.'
  }
];
